

const users = [
    {
        id: 1,
        title: 'What is Armadillos NFT ?',
        info:
            'An organization which combines the NFT community and our clothing brand .'
    },
    {
        id: 2,
        title: `Which one are we ? NFT's or Cloathing Brand ?`,
        info:
            'We are a community that grown with our NFT and clothing brand .            '
    },
    {
        id: 3,
        title: "The team members ?" ,
        info:
            'Four friends who are trying to produce an effect with their unique thoughts and the way of working .'
    },
    {
        id: 4,
        title: 'Will Armadillos NFT save the world ?',
        info:
            'We are not saving the world, just a smile is enough for us, join the community .'
    },
    {
        id: 5,
        title: 'Are we taking special order to cloathing ?',
        info:
            'Yes, we design as you desire, contact us . '
    },
];


export default users


